import * as React from "react";
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import theme from '../components/theme';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { getAuth } from "firebase/auth";
import SurveyStatusTable from '../components/SurveyStatusTable'

function SurveyStatus() {
  const auth = getAuth();
  const userUid = React.useMemo(() => (auth.currentUser && auth.currentUser.emailVerified) ? auth.currentUser.uid : null, [auth.currentUser]);
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="md">
        <CssBaseline />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: 'analogous.main' }}>
                <FormatListBulletedIcon/>
              </Avatar>
              <Typography component="h1" variant="h5">
                Assessment Status
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center">
              Check your assessment request history and see the status of assessments.
              </Typography>
              <SurveyStatusTable
                userUid={userUid}
              />
            </Box>
        <br></br>
        <br></br>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}

export default SurveyStatus;